






import { Component, Vue } from 'vue-property-decorator';
/* import { Switch as cSwitch } from '@coreui/vue' */

@Component({
  components: {
    /* cSwitch */
  },
})
export default class DefaultAside extends Vue {}
